import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { WindowTypes, selectWindowType } from 'store/pageStore';
import { checkScreenType } from 'utils';
import { stepStyles } from './styles';

type StepProps = {
	header: string;
	text: string;
	stepImg: string;
	stepImgMin?: string;
	stepImgTab: string;
	stepImgTabMin?: string;
	stepImgMob: string;
	index: number;
	className?: string;
};
export const Step = ({
	className = '',
	header,
	text,
	stepImg,
	stepImgMin,
	stepImgTab,
	stepImgTabMin,
	stepImgMob,
	index,
}: StepProps) => {
	const currentWindowType = useSelector(selectWindowType);
	const isMobile = checkScreenType(currentWindowType, WindowTypes.mobile);
	return (
		<div className={`${stepStyles} ${className}`}>
			<div className="step__img-container">
				<img className="step__img step__img--desktop" src={stepImg} />
				{!!stepImgMin && (
					<img
						className="step__img step__img--desktop step__img--desktop-min"
						src={stepImgMin}
						id="stepImgMin"
					/>
				)}
				<img className="step__img step__img--tablet" src={stepImgTab} />
				{!!stepImgMin && (
					<img
						className="step__img step__img--tablet step__img--tablet-min"
						src={stepImgTabMin}
					/>
				)}
				<img className="step__img step__img--mob" src={stepImgMob} />
			</div>
			<div className="step__text-container">
				<div className="step__text__index">{index}</div>
				<div className="step__text__header">
					<Typography variant="h3">{header}</Typography>
				</div>
				<div className="step__text__text">
					<Typography variant={isMobile ? 's' : 'm'} size="body_long">
						{text}
					</Typography>
				</div>
			</div>
		</div>
	);
};
